<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12 col-sm-12 col-xs-12">
                        <h4 class="card-title">
                            Анкети
                        </h4>
                    </div>
                </div>

                <div class="row" style="padding-top: 15px;">
                    <div class="col-12">
                        <div class="table-responsive">
                            <table datatable class="table">
                                <thead>
                                <tr class="bg-primary text-white">
                                    <th>#</th>
                                    <th>Анкета</th>
                                    <th>Дата на добавяне</th>
                                    <th>Финализирана</th>
                                </tr>
                                </thead>
                                <tbody>

                                <tr *ngFor="let survey of surveys">
                                    <td>{{ survey.id }}</td>
                                    <td>
                                        <ng-container *ngIf="!survey.is_finished">
                                            {{ survey.survey_title }}
                                        </ng-container>

                                        <ng-container *ngIf="survey.is_finished">
                                            <del>{{ survey.survey_title }}</del>
                                        </ng-container>
                                    </td>
                                    <td>{{ formatDate(survey.created_at) }}</td>
                                    <td [ngSwitch]="survey.is_finished">
                                        <label *ngSwitchCase="true" class="badge badge-success">завършена</label>

                                        <a
                                                *ngSwitchCase="false"
                                                (click)="redirectToSurvey(survey.id)"
                                                class="answer-btn btn btn-primary btn-icon-text">
                                            <i class="ti-pencil btn-icon-prepend"></i>
                                            Отвори и отговори на въпросите
                                        </a>
                                    </td>
                                </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
